// GtRecordKit — small shared pieces for the record pages and Home (the gtr2
// layout): stroke icons that sit with 12px type, and the stat-strip cell.
// Styles live in the gtr2 block of gt.css.

export const ICONS = {
  back: 'M15 18l-6-6 6-6',
  pin: 'M12 21s-7-6.1-7-11.5A7 7 0 0 1 19 9.5C19 14.9 12 21 12 21zM12 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
  spark: 'M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z',
  rate: 'M12 2v20M17 6H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6',
  cal: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',
  mail: 'M3 6h18v12H3zM3 7l9 6 9-6',
  link: 'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1',
  globe: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM3 12h18M12 3c2.5 2.7 3.8 5.7 3.8 9s-1.3 6.3-3.8 9c-2.5-2.7-3.8-5.7-3.8-9S9.5 5.7 12 3z',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM5 20a7 7 0 0 1 14 0',
  users: 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 20a6 6 0 0 1 12 0M16 4.3a3.5 3.5 0 0 1 0 6.4M18 14.5a6 6 0 0 1 3 5.5',
  building: 'M4 21V5l8-3v19M12 21V9l8 3v9M3 21h18M8 8v.01M8 12v.01M8 16v.01M16 15v.01M16 18v.01',
  brief: 'M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M4 7h16v12H4zM4 12h16',
  code: 'M8 7l-5 5 5 5M16 7l5 5-5 5',
  doc: 'M6 3h8l4 4v14H6zM14 3v4h4M9 13h6M9 17h6',
  down: 'M12 4v11M7 10l5 5 5-5M5 20h14',
  caret: 'M7 10l5 5 5-5',
  plus: 'M12 5v14M5 12h14',
  edit: 'M4 20h4L19 9l-4-4L4 16zM14 6l4 4',
  share: 'M18 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM18 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM8.6 13.5l6.8 4M15.4 6.5l-6.8 4',
  board: 'M4 4h5v16H4zM10 4h5v10h-5zM16 4h4v7h-4z',
  dots: 'M5 12h.01M12 12h.01M19 12h.01',
  block: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM5.6 5.6l12.8 12.8',
  alert: 'M12 3l10 18H2zM12 10v5M12 18h.01',
  check: 'M5 12l4 4L19 6',
  chat: 'M4 5h16v11H9l-5 4z',
  send: 'M4 12l16-8-6 16-2-7z',
  layers: 'M12 3l9 5-9 5-9-5zM3 13l9 5 9-5',
  clip: 'M20 11l-8.5 8.5a5 5 0 0 1-7-7L13 4a3.5 3.5 0 0 1 5 5l-8.5 8.5a2 2 0 0 1-3-3L14 7',
  bolt: 'M13 2L4 14h7l-1 8 9-12h-7z',
  clock: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 7v5l3 2',
  arrow: 'M5 12h14M13 6l6 6-6 6',
};

export function Ico({ d, cls, size }) {
  const s = size || 14;
  return (
    <svg className={'gtr2-ico' + (cls ? ' ' + cls : '')} viewBox="0 0 24 24" width={s} height={s} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={d} />
    </svg>
  );
}

export function Stat({ label, value, sub, onClick }) {
  if (onClick) {
    return <button type="button" className="gtr2-stat gtr2-stat--go" onClick={onClick}><span>{label}</span><b>{value}</b>{sub ? <em>{sub}</em> : null}</button>;
  }
  return <div className="gtr2-stat"><span>{label}</span><b>{value}</b>{sub ? <em>{sub}</em> : null}</div>;
}
